
import * as z from "zod";

// Define form validation schema
export const journalSchema = z.object({
  stuck_point: z.string().min(1, "Please describe what you're stuck on"),
  perception_response: z.string().optional(),
  intention_response: z.string().optional(),
  next_step_response: z.string().optional(),
  twist_response: z.string().optional(),
});

export type JournalFormValues = z.infer<typeof journalSchema>;
